import React, { useState, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { useSelector } from "react-redux";
import { getNextLevel, getFavorites, getRecent } from "utils/builder/IModelsTree";
import { useDashboardState } from "components/DashboardContext";
import { useElementSize } from "utils/helpers";
import "./DashboardEmpty.scss";

import ProjectNav from "components/sidebarComponents/ProjectNav";
import WelcomeModal from "components/modals/WelcomeModal";
import TrialPeriodExpiredModal from "components/modals/TrialPeriodExpiredModal";
import ModalComponent from "components/modals/ModalComponent";
import HubContactButton from "components/HubContactButton";
import SearchInput from "components/uiComponents/SearchInput";
import Button from "components/uiComponents/Button";
import FolderExplorer from "components/FolderExplorer";
import {subscriptionType} from "../../utils/data";

import ClockIcon from "static/icons/clock.svg";
import StarIcon from "static/icons/star.svg";

const DashboardEmpty = () => {
  const {
    activeFolder,
    isWelcomeModalSeen,
    signingState,
    setFavourites,
    setRecent,
    setActiveFolder,
    setIsFolderLoading,
    setIsWelcomeModalSeen,
    recent,
    favourites
  } = useDashboardState();

  const searchRef = useRef(null);
  const { subscreption } = useSelector((state) => state.user.info);

  const [searchWidth, searcHeight] = useElementSize(searchRef?.current);
  const [list, setList] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [tree, setTree] = useState({});
  const [isWelcomeModalVisible, setIsWelcomeModalVisible] = useState(false);
  const [isTrialPeriodExpiredModal, setTrialPeriodExpiredModal] = useState(false);
  const [isHubButtonVisible, setIsHubButtonVisible] = useState(true);
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  const closeTrialPeriodExpiredModal = () => {
    setTrialPeriodExpiredModal(false);
  };

  const handleCloseWelcomeModal = () => {
    setIsWelcomeModalVisible(false);
  };

  useEffect(() => {
    if(subscreption === subscriptionType.blocked) {
      setTrialPeriodExpiredModal(true);
    }
  }, [subscreption]);

  useEffect(() => {
    if (signingState === 2) {
      if (!isWelcomeModalSeen) {
        setTimeout(() => {
          setIsWelcomeModalVisible(true);
          setIsWelcomeModalSeen(true);
        }, 1000);
      }
    }
  }, [signingState]);

  useEffect(() => {
    const treea = JSON.parse(localStorage.getItem("tree"));

    getNextLevel("#").then((res) => {
      setList(res);
    });

    setTree(treea ? treea : {});
  }, []);

  useEffect(() => {
    if(activeFolder === null || activeFolder === 'recent') {
      if(!recent) {
        handleRecentClick()
      }
    }
    if(activeFolder === 'favourites') {
      if(!favourites) {
        handleFavouritesClick()
      }
    }
  },[])

  const handleSearch = (e) => {
    const value = e.target.value;

    if (e.keyCode === 13) {
      setSearchValue(value);
    }
  };

  const handleRecentClick = () => {
    setActiveFolder('recent');
    setIsFolderLoading(true);

    getRecent()
      .then(res => {
        setRecent({
          text: 'Recent',
          childrenArr: res,
        });
        setIsFolderLoading(false);
      })
  };

  const handleFavouritesClick = () => {
    setActiveFolder('favourites');
    setIsFolderLoading(true);

    getFavorites()
      .then(res => {
        setFavourites({
          text: 'Favorites',
          childrenArr: res,
        });
        return res;
      })
      .then(() => {
        setIsFolderLoading(false);
      });
  };

  const handleHideHelp = () => {
    setIsHubButtonVisible(false);
  };

  const handleChangeSearchVisibility = () => {
    if (!isSearchVisible) {
      setIsSearchVisible(true);
    }
  };

  const handleHideSearch = () => {
    setIsSearchVisible(false);
    setSearchValue("");
  };

  return (
    <>
      <div className="dashboard-empty">
        <div className="dashboard-empty__nav">
          <div className="tree__container">
            <div className="tree__header">
              <Button
                isCommon={true}
                isFullWidth
                clickFunction={handleRecentClick}
                isActive={activeFolder === 'recent'}
              >
                <img src={ClockIcon} />

                <p className="tree__btn_text">
                  Recent
                </p>
              </Button>

              <div className="tree__btn_wrapper">
                <Button
                  isCommon={true}
                  isFullWidth
                  clickFunction={handleFavouritesClick}
                  isActive={activeFolder === 'favourites'}
                >
                  <img src={StarIcon} />

                  <p className="tree__btn_text">
                    Favorites
                  </p>
                </Button>
              </div>
            </div>

            <div className="tree__content">
              <div className="tree__content_header">
                <CSSTransition
                  in={!isSearchVisible}
                  timeout={150}
                  unmountOnExit
                  classNames="dashboard-empty__help"
                >
                  <p className="tree__content_title">
                    My projects
                  </p>
                </CSSTransition>

                <div
                  ref={searchRef}
                  className="tree__content_search"
                >
                  <SearchInput
                    type="text"
                    name="sideSearch"
                    className="find"
                    placeholder="Search your project..."
                    width={searchWidth}
                    isVisible={isSearchVisible}
                    onChange={handleSearch}
                    onChangeVisibility={handleChangeSearchVisibility}
                    onHideSearch={handleHideSearch}
                  />
                </div>
              </div>

              <div className="sidebar-expanded">
                <ProjectNav
                  isWithoutTitle
                  isWithoutSearch
                  outsideSearchValue={searchValue}
                />
              </div>
            </div>
          </div>

          <div className="folder-explorer">
            <FolderExplorer />
          </div>
        </div>

        <CSSTransition
          in={!!isHubButtonVisible}
          timeout={150}
          unmountOnExit
          classNames="dashboard-empty__help"
        >
          <div className="dashboard-empty__help">
            <HubContactButton
              onHideHelp={handleHideHelp}
            />
          </div>
        </CSSTransition>
      </div>

      <ModalComponent
        onCloseModal={handleCloseWelcomeModal}
        isVisible={isWelcomeModalVisible}
      >
        <WelcomeModal
          onActionClick={handleCloseWelcomeModal}
        />
      </ModalComponent>

      <ModalComponent
        onCloseModal={closeTrialPeriodExpiredModal}
        isVisible={isTrialPeriodExpiredModal}
      >
        <TrialPeriodExpiredModal />
      </ModalComponent>
    </>
  );
};

export default DashboardEmpty;
